  <div class="footer-container">
    <div class="footer-inner">
      <p>Powered by <a [href]="hadsuppage"><img src="assets/images/footer_hadsup_logo.svg" alt="Logo" /></a></p>
    </div>
</div>
